export class ShipmentOrderPackage {
    Id: string | null;
    Tenant: number | null;
    ShipmentId: string | null;
    IsContainer: boolean | null;
    PackageTypeId: string | null;
    ContainerTypeId: string | null;
    Quantity: number | null;
    GrossWeight: number | null;
    Volume: number | null;
    Height: number | null;
    Width: number | null;
    Length: number | null;
    VolumetricWeight: number | null;
    PackageTypeName: string | null;
    Dimensions: string | null;
}